import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Box, Typography, TextField, Button, Rating } from "@mui/material";
import 'react-toastify/dist/ReactToastify.css';
import ToastService from "@/service/toaster.service";
import venderService from "@/service/vender.service";
import LoginPopup from "@/common/LoginPopup";

function WriteReviewSection({ VendorDetail, updateVendorRating }) {
  const [Venderdetail, setVenderdetail] = useState(VendorDetail);
  const isAuthenticated = Boolean(localStorage.getItem("access_token"))
  const [rating, setRating] = useState(0);
  const [review, setReview] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState("");
  const customerId = useSelector((state) => state.auth.auth._id);
  const vendorId = Venderdetail._id;

  const handleRatingChange = (newRating) => {
    setRating(newRating);
  };

  const handleReviewChange = (e) => {
    setReview(e.target.value);
  };

  const handleSubmit = async () => {
    if (!isAuthenticated) {
      setRedirectUrl("/customer/auth/login");
      setShowPopup(true);
      return;
    }
    if (!rating || !review.trim()) {
      ToastService.warning("Please provide a rating and a review.");
      return;
    }

    setLoading(true);
    setError("");
    setSuccess("");

    try {
      const response = await venderService.submitReview({
        customer: customerId,
        vendor: vendorId,
        rating,
        comment: review,
      });
      if (response.status) {
        ToastService.success("Review submitted successfully!");
        const updatedVendor = await venderService.fetchVendorById(vendorId);
        updateVendorRating(updatedVendor);

        setSuccess("Review submitted successfully!");
        setRating(0);
        setReview("");
        return;
      }
    } catch (error) {
      setError("Failed to submit review. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Box
        sx={{
          backgroundColor: "#fbfcff",
          border: "1px solid #d9d9d9",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          width: "100%",
          mt: 1,
          p: 3,
          borderRadius: 1,
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
          Write a Review
        </Typography>

        {/* Rating Section */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 1 }}>
          <Typography sx={{ color: "#6e6d6a", fontSize: 16, fontWeight: 500 }}>
            Submit Stars
          </Typography>
          <Rating
            name="rating"
            value={rating}
            onChange={(e, newValue) => handleRatingChange(newValue)}
            max={5}
            sx={{ ml: 1 }}
          />
        </Box>

        {/* Review Section */}
        <TextField
          label="Write your reviews..."
          multiline
          rows={3}
          value={review}
          onChange={handleReviewChange}
          variant="outlined"
          fullWidth
          sx={{
            backgroundColor: "#fff",
            borderRadius: 1,
            mb: 1,
            "& .MuiOutlinedInput-root": {
              borderColor: "#dddad4",
            },
          }}
        />

        {/* Submit Button */}
        <Button
          variant="contained"
          color="primary"
          sx={{
            textTransform: "uppercase",
            borderRadius: 1,
            fontWeight: 600,
            fontSize: 16,
            py: 1,  // Even less padding for a smaller height
            mt: 1,
            width: "auto",  // Reduced width
            mx: "auto",  // Center the button horizontally
          }}
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Submitting..." : "Submit Review"}
        </Button>
      </Box>
      {showPopup && (
        <LoginPopup
          onClose={() => setShowPopup(false)}
          redirectUrl={redirectUrl}
        />
      )}</>
  );
}

export default WriteReviewSection;
